import { DespatchAdviceItem } from '../../data/models'
import i18n from '../../utils/i18n'

export const DeliveryStatusBodyTemplate = (
  deliveryStatus: DespatchAdviceItem['DeliveryStatus'],
) => {
  if (!deliveryStatus) return null

  return (
    <>
      {i18n.t(`common.codes.deliveryStatus.${deliveryStatus?.toLowerCase()}`)}
    </>
  )
}
